<template>
  <div>
    <!-- aaaaaaaaaaaa -->
    <template v-for="(s_item, idx) in newItem.sub_items">
      <v-col cols="12" :key="'r-si' + idx" class="py-0">
        <v-row align="center" class="px-2">
          <v-text-field
            class="mr-10"
            v-model="s_item.name"
            :prepend-icon="
              `mdi-numeric-${idx + 1 < 10 ? idx + 1 : '9-plus'}-${
                newItem.kind == 'options' ? 'circle' : 'box'
              }`
            "
            :rules="[ruleRequired('Campo obrigatório!')]"
            :label="'Item ' + (idx + 1)"
            color="secondary"
          ></v-text-field>

          <v-btn small text fab color="error" :disabled="idx == 0 && newItem.sub_items.length == 1" @click="removeSubItem(idx)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </template>
    <v-col cols="12">
      <v-btn class="ml-10" text color="secondary" @click="addSubitem()" rounded>
        <v-icon left>mdi-plus</v-icon>opção
      </v-btn>
    </v-col>
    <v-col>
      <v-divider></v-divider>
    </v-col>

    <dialog-loading v-if="loading"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import validations from "@/mixins/validations";

export default {
  mixins: [validations],
  data() {
    return {
      loading: false,
      loadingText: null,
      newItem: this.$attrs.newItem,
    };
  },
  methods: {
    removeSubItem(i) {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Excluir item?",
          text: "Essa ação é irreversível",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: this.$vuetify.theme.themes['light'].primary,
          cancelButtonText: "Não",
        });

        if (confirmation) {
          this.loading = true;
          setTimeout(() => {
            let qtd = this.newItem.sub_items.splice(i, 1);
            // auto-comment// console.log({qtd});
            this.loading = false;
          }, 1000);

          if (qtd[0].id) {
            // auto-comment// console.log('has id');
            // Api.Item.delete(qtd[0].id)
          }
        }
      })();
    },
    addSubitem() {
      this.loading = true;
      setTimeout(() => {
        this.newItem.sub_items.push({});
        this.loading = false;
      }, 1000);
    },
    ...mapActions({
      // function: 'Module/action'
    }),
  },
  computed: {
    names() {
      return null;
    },
    ...mapState({
      // data: state=> state.Module.state_var
    }),
  },
  mounted() {
    if (this.newItem.sub_items.length == 0) {
      this.addSubitem();
    }
    // this.newItem.sub_items = [{}]
  },
  watch: {
    data(nv, ov) {
      if (nv) {
      } else if (nv == false) {
      }
    },
  },
};
</script>

<style scoped></style>
